import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { CreateFolderSharingsExternalRequest, CreateFolderSharingsExternalResponse } from "@maven-rest/docs/FolderSharing.dto";
import { FolderSharingUrl } from "@maven-rest/docs/FolderSharing.url";

export function useCreateFolderSharingsExternalMutation(
  options?: SimpleMutationOptions<CreateFolderSharingsExternalResponse, CreateFolderSharingsExternalRequest>
) {
  return useBaseMutation({
    fnOption: { url: FolderSharingUrl.createFolderSharingsExternal },
    ...options,
  });
}
